import { dataCropSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCropSolid = /*#__PURE__*/createIcon(dataCropSolid)
export default IconCropSolid
